import { Stack, Typography } from "@mui/material";
import type { FC } from "react";
import { Controller, useFormContext, useWatch } from "react-hook-form";
import type { MomentFormMoment } from "../../../moment/types/moment-form-moment";
import { TimeZoneSelector } from "../time-zone-selector";
import type { ScheduleFormV2LayoutProps } from "./types";

export const ScheduleTimezoneSelector: FC<
  Omit<ScheduleFormV2LayoutProps, "showValidationErrors"> & { label?: string }
> = ({ disabled, label }) => {
  const { control, getValues } = useFormContext<MomentFormMoment>();

  useWatch({ control, name: ["target_channel"] });
  const [targetChannel] = getValues(["target_channel"]);

  return (
    <Stack direction="column" sx={{ ml: 1 }}>
      <Controller
        name="timezone"
        control={control}
        render={({ field }) => (
          <TimeZoneSelector
            value={field.value}
            onChangeTimeZone={field.onChange}
            disabled={disabled}
            targetChannel={targetChannel}
            label={label}
          />
        )}
      />
      {targetChannel && (
        <Typography variant="body2" color="text.discreet" sx={{ mx: 2, mt: 1 }}>
          Recipients’ local time is not available for Channel in Slack / Teams
        </Typography>
      )}
    </Stack>
  );
};
